module.exports = __webpack_public_path__ + "public/img/bar-3.68bd60d6.png";